import { ServiceBase } from './ServiceBase'

export class Holidays extends ServiceBase {}
